import { Box, Container, CssBaseline, Stack, Toolbar } from '@mui/material';
import { useState } from 'react';
import ExampleControls from '../Components/Examples/ExampleControls';
import ExampleList from '../Components/Examples/ExampleList';
import ProjectsHeader from '../Components/Projects/ProjectsHeader';

const ExamplesPage = () => {
  const [filterTag, setFilterTag] = useState('All');
  const handleClick = (tag: string) => {
    setFilterTag(tag);
  };

  return (
    <>
      <CssBaseline />
      <Container
        sx={{
          height: 'calc(100vh - 50px)',
          padding: '24px',
          margin: '0',
          flexGrow: 1,
          overflowY: 'auto',
          width: '100%',
        }}
        maxWidth={false}
      >
        <Box>
          <Stack spacing={1}>
            <Toolbar />
            <Stack spacing={2}>
              <ProjectsHeader />
              <ExampleControls filterTag={filterTag} handleClick={handleClick} />
              <ExampleList filterTag={filterTag} />
            </Stack>
          </Stack>
        </Box>
      </Container>
    </>
  );
};

export default ExamplesPage;
